<template>
  <n-scroll>
    <div class="device-page">
      <template v-for="(item, index) in list">
        <list-item
          :key="index"
          :label="item.label"
          :value="item.value"
          :custom-style="itemStyle"
          :has-border="index != list.length - 1"
        />
      </template>
    </div>
  </n-scroll>
</template>

<script>
import NScroll from '../../components/NScroll';
import ListItem from '../../components/ListItem';
import { propFilter } from '@/utils/utils';

export default {
  components: {
    ListItem,
    NScroll
  },
  inject: ['calc', 'params'],
  computed: {
    itemStyle() {
      return { padding: this.calc(30) };
    },
    list() {
      const label = {
        deviceName: '设备名',
        sn: '序列号',
        deviceTypeCode: '型号'
      };
      const obj = propFilter(this.params, Object.keys(label));
      return Object.keys(label).map(key => ({ label: label[key], value: obj[key] || '--' }));
    }
  }
};
</script>

<style lang="scss">
.device-page {
  padding: 0 12px 12px;
}
</style>
